import React from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "./Navbar";

interface Props {
  children: React.ReactNode;
}

const Layout: React.FC<Props> = ({ children }) => {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  return (
    <div className={`app-layout${isHome ? " layout-home" : ""}`}>
      <Navbar />
      <main className="main-content">{children}</main>
      <footer className="footer">
        <div className="golden-thread golden-thread-footer" aria-hidden="true" />
        <p>Ticketed Wedding</p>
        <p className="footer-brand-note">A Pash Company Brand</p>
        {isHome && (
          <p className="footer-photo-credit">
             Hero Image by{" "}
            <a
              href="https://unsplash.com/@nate_dumlao?utm_source=medium&utm_medium=referral"
              target="_blank"
              rel="noopener noreferrer"
            >
              Nathan Dumlao
            </a>
          </p>
        )}
        <p className="footer-links">
          <Link to="/privacy">Privacy</Link>
          <span aria-hidden="true"> · </span>
          <Link to="/terms">Terms</Link>
        </p>
      </footer>
    </div>
  );
};

export default Layout;
